/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

/* eslint-disable max-len */

import { Base64 } from 'js-base64';

export const port = process.env.PORT || 3000;
export const host = process.env.WEBSITE_HOSTNAME || `localhost:${port}`;

export const SERVER_TEST = 'https://xuetang-test6.youdao.com/course3/api/'
export const SERVER_ONLINE = 'https://ke.youdao.com/course3/api/'

export const SERVER = process.env.NODE_ENV !== 'production' ? SERVER_TEST : SERVER_ONLINE
export const API_SERVER = process.env.API_SERVER || SERVER

export const API_COURSE_SERVER = process.env.NODE_ENV !== 'production' ?
  'https://xuetang-test6.youdao.com/' : 'https://ke.youdao.com/'

export const COURSE_DETAIL = `${API_COURSE_SERVER}course/detail/`
// 云课堂课堂详情页地址
export const COURSE_STUDY_DETAIL = 'https://ke.study.163.com/course/detail/'

export const PAYMENT_SERVER = SERVER.replace('course3/api', 'course/app')
export const PAYMENT_SUBMIT = process.env.NODE_ENV !== 'production' ? 'https://ke.youdao.com/pay/ordersubmit/' :
  'https://ke.youdao.com/pay/ordersubmit/'

export const isBrowser = process.env.BROWSER

export const USER_CENTER_URL = 'https://kewap.youdao.com/user'
export const WEB_URL_INDEX = process.env.NODE_ENV !== 'production' ? 'https://xuetang-test6.youdao.com' :
  'https://ke.youdao.com'
export const WAP_URL_INDEX = 'https://ke.youdao.com/wap/'
export const LOGIN_PAGE = `${WEB_URL_INDEX}/login?back_url=`
export const BIND_PAGE = `${WEB_URL_INDEX}/user/bind/bindmobile?back_url=`
export const WAP_LOGIN_PAGE = 'https://ke.youdao.com/wap/login'
export const COURSE_LIST = 'https://kewap.youdao.com/m/course/list/0/1'
export const COURSE_LIST_WEB = 'https://ke.youdao.com/m/course/list/0/1'
export const MY_COURSE = 'https://ke.youdao.com/user/mycourse'
export const LIVE_COURSE = 'http://live.youdao.com/live/index.html'
// 云课堂直播地址
export const LIVE_STUDY_COURSE = 'https://live.study.163.com/live/index.html'
export const APP_DOWNLOAD_WAP = 'https://c.youdao.com/xue/wap/appDownload.html'
// 云课堂成人教育域名
export const ADULT_STUDY_SERVER = 'https://ke.study.youdao.com/'


// 登录验证接口(http or https)
export const LOGIN_AUTH_URL = process.env.NODE_ENV !== 'production' ? 'https://dict.youdao.com/login/acc' : 'https://dict.youdao.com/login/acc'
// 第三方登录配置
export const THIRD_LOGIN = {
  qq: { name: 'qq', tp: 'cqq' },
  wb: { name: 'weibo', tp: 'tsina' },
  wx: { name: 'weixin', tp: 'weixin-web-xue' },
}
// 网易手机号登录配置，参考wiki：http://doc.hz.netease.com/pages/viewpage.action?pageId=95165028
export const MOBILE_LOGIN_CONF = {
  // 全局配置
  // 产品ID,【必须】
  product: 'youdaodict',
  promark: 'MPWUAQf',
  // 滑块验证码的产品号,【必须】,注意大小写，产品必须同时接入滑块与图片验证码（hzzhouyoukai@corp.netease.com）
  productKey: 'a46c7d22ccc2da4b88e4bcb0c73870b6',
  version: 3,
  newCDN: 1,
  host: 'www.youdao.com', // 组件所在域名
  // 滑块验证码宽度,不能小于220，建议大点防止被破解,【必须】
  swidth: '320',
  isHttps: 1,
  // 邮箱登录，邮箱注册，手机帐号登录，手机帐号注册，锁定状态文案,【可选】
  lockConfig: {
    loginLockTxtMb: '登 录',
  },
  includeBox: 'mobileLogin', // 内嵌模式需要插入的Dom节点ID,【可选】
  domains: '163.com,126.com,vip.com,youdao.com', // 登录成功后要设置哪些域cookie
  cookieDomain: 'youdao.com', // 非163域名必选
  skin: 3,
  cssDomain: 'https://shared-https.ydstatic.com/', // 【可选】,自定义样式的地址，注意：必须是绝对路径，即含有完整的‘http：//’‘https://’协议头
  cssFiles: 'ke/login/20200701/weblogin.css', // 【可选】,自定义样式文件:使用样式覆盖方式进行样式自定义。强烈建议，css在head部分预先加载！
  single: 1,
  // 首屏,【可选】,注册:register，登录:login，根据实际情况填入.(此开关配合mobileFirst 可以确定首屏模块)
  page: 'login',
  customStyles: {
    imagePanel: {
      align: 'bottom', // 易盾在float模式下生效，指定imagePanel出现在controlBar上方还是下方。
    },
  },
  // 手机密码登录相关配置
  // 文案相关
  mbBtnTxt: '登 录', // 手机密码登录按钮文案,【可选】
  mobilePlaceholder: {
    mobile: '请输入手机号码', // 手机密码登录文案
    pwd1: '请输入密码', // 手机密码登录文案
  },
  // 配置
  needMobileLogin: 1, // 需要手机帐号登录模块,【可选】
  mobileFirst: 1, // 手机帐号相关模块优先展示,【可选】
  smsLoginFirst: 1, // 优先短信登录方式,【可选】
  mbNeedItl: 1, // 手机帐号登录和注册是否支持国际手机号,【可选】
  noqr: 1, // 设置手机帐号是否隐藏二维码登录,【可选】

  // 手机验证码登录+注册模块相关配置，统一在uniteLogin对象下
  uniteLogin: {
    loginTxt: '登 录', // 手机验证码登录按钮文案
    isItl: 1, // 是否国际号
    first: 1, // 是否统一登录是首屏
    needClause: 0, // 是否需要条款
    placeholders: {
      mob: '请输入手机号码',
      sms: '请输入验证码',
    },
  },
}

export const MAIL_LOGIN_CONF = {
  product: 'youdaodict',
  promark: 'MPWUAQf',
  productKey: 'a46c7d22ccc2da4b88e4bcb0c73870b6',
  version: 3,
  newCDN: 1,
  host: 'www.youdao.com',
  swidth: '320',
  isHttps: 1,
  lockConfig: {
    loginLockTxtMb: '登 录',
  },
  includeBox: 'mailLogin',
  domains: '163.com,126.com,vip.com,youdao.com',
  cookieDomain: 'youdao.com',
  skin: 3,
  cssDomain: 'https://shared-https.ydstatic.com/',
  cssFiles: 'ke/login/20200701/weblogin.css',
  single: 1,
  page: 'login',
}

// 支付方式
export const PayMode = {
  wechat: 'wechat',
  alipay: 'alipay',
}

// 云课堂置换cookie中间页地址
export const SET_COOKIE_URL = 'https://study.youdao.com/passport/adult/changeCookiesWithNoDict.htm?single=false&returnUrl=';

/**
 * 跳转地址处理，跳转到云课堂页面前请调用该方法，先置换cookie
 * @param {String} url  跳转目标地址
 */
export const getUrl = (url) => {
  // 提取域名
  const regexp = /^(https|http)?:\/\/[\w-.]+(:\d+)?/i.exec(url);
  let domain;

  if (regexp && regexp.length) {
    domain = regexp[0] || '';
  }

  if (!domain) {
    return url;
  }
  // 是不是云课堂的域名
  const isStudy = domain.includes('study');

  // 不是云课堂的域名
  if (!isStudy) {
    return url;
  }


  // 调置换cookie接口,往云课堂域写cookie
  return `${SET_COOKIE_URL}${Base64.encode(url)}`;
};



// WEBPACK FOOTER //
// ./src/config.js